"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var colorConfig_1 = require("./colorConfig");
var ColorPickerToolContainer_1 = __importDefault(require("./ColorPickerToolContainer"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a;
    return ({
        root: {
        // padding: 8,
        },
        toolPart: (_a = {
                display: 'flex'
            },
            _a[theme.breakpoints.down((colorConfig_1.PICKER_TOOL_WIDTH + theme.spacing(0.5)) * 2)] = {
                display: 'block'
            },
            _a)
    });
});
var ColorPickerToolList = function (_a) {
    var labelsAndRefs = _a.labelsAndRefs, handleSetThemeColorFn = _a.handleSetThemeColorFn;
    var classes = useStyles();
    return (react_1.default.createElement(core_1.Box, { className: classes.root },
        react_1.default.createElement(core_1.Box, { className: classes.toolPart }, labelsAndRefs.map(function (labelAndRef, i) { return (react_1.default.createElement(ColorPickerToolContainer_1.default, { key: i, label: labelAndRef.tabLabel, ref: labelAndRef.ref })); })),
        react_1.default.createElement(core_1.Button, { onClick: handleSetThemeColorFn, variant: 'contained', color: 'primary' }, 'set theme')));
};
exports.default = ColorPickerToolList;
